/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Template_LabelInputs */



/**
* | output |
* | --- |
* | "CCSL Template" |
*
* @param {Ccsl_Export_Template_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_template_label = /** @type {((inputs?: Ccsl_Export_Template_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Template_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modele CCSL")
	if (locale === "de") return /** @type {LocalizedString} */ ("CCSL-Vorlage")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modello CCSL")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Шаблон CCSL")
	if (locale === "es") return /** @type {LocalizedString} */ ("Plantilla CCSL")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("CCSL模板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CCSL テンプレート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सीसीएसएल टेम्पलेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modelo CCSL")
	return /** @type {LocalizedString} */ ("CCSL Template")
});